<template>
  <div ref="scrollWraper" class="lists">
    <slot></slot>
    <div class="pullUp-ext" v-if="isPullUp" :style="{top: `calc(100% + ${pullUpTop}px)`}">
      <slot name="loading" v-if="loading">
        <!-- <spinner :show="true" stroke="#999"></spinner> -->
      </slot>
      <!-- <slot name="load-more" v-if="loadMore">- 上拉加载更多 -</slot> -->
      <slot name="no-more" v-if="noMore">没有更多了</slot>
      <slot name="no-results" v-if="noResult">暂时没有数据</slot>
    </div>
  </div>
</template>

<style scoped>
  .lists {
    position: relative;
  }

  .pullUp-ext {
    position: absolute;
    width: 100%;
    top: calc(100% - 0);
    text-align: center;
    padding: 10px;
  }
</style>

<script>
import BScroll from 'better-scroll';
import Spinner from '@/components/spinner';

// const DirectionTop = 1;

export default {
  props: {
    options: Object,
    data: Array,
    scrollMode: Boolean,
    scrollRefresh: Boolean
  },

  watch: {
    data (v) {
      this.pullUping = false;
      this.$nextTick(() => {
        this.scroll.refresh();
      });
    },
    scrollRefresh () {
      this.pullUping = false;
      this.$nextTick(() => {
        this.scroll.refresh();
      });
    }
  },

  computed: {
    // loadMore () {
    //   return !this.loading && !this.noMore && !this.noResult;
    // },
    isPullUp () {
      return this.options.pullUpLoad;
    },
    loading () {
      return this.pullUping && !this.noMore;
    }
  },
  components: {
    Spinner
  },

  data () {
    return {
      // loading: false,
      noMore: false,
      noResult: false,
      pullUping: false,
      pullUpTop: 0,
      sta: {
        complete: () => {
          this.noMore = true;
          this.scroll.finishPullUp();
        },
        loaded: () => {
          this.scroll.finishPullUp();
        }
      }
    };
  },

  methods: {
    reset () {
      this.noMore = false;
      this.noResult = false;
      this.pullUping = false;
      this.pullUpTop = 0;
      this.scroll.finishPullUp();
    },
    init () {
      if (!this.scrollMode) return;
      this.scroll = new BScroll(this.$refs.scrollWraper, this.options);
      if (this.options.pullUpLoad) {
        this.scroll.on('pullingUp', () => {
          if (this.noMore || this.noResult) {
            return;
          }
          this.pullUping = true;
          this.$emit('pullingUp', this.sta);
        });

        this.scroll.on('scroll', pos => {
          if (this.scroll.maxScrollY > pos.y && this.pullUping) {
            this.pullUpTop = pos.y - this.scroll.maxScrollY;
          }
        });

        this.scroll.on('scrollEnd', pos => {
          this.pullUpTop = 0;
        });
      }
    }
  },

  mounted () {
    this.init();
  }
};
</script>



// WEBPACK FOOTER //
// src/core/models/scroll.vue